import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

export const StyledReferralDialog = styled(Dialog)`
  z-index: 10000;
  .MuiPaper-root {
    margin: 16px;
    border-radius: 16px;
    max-width: 640px;
  }
  .dialog-title {
    font-weight: 500;
    padding: 0;
    color: ${COLOR.dark};
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
  }

  .title {
    color: ${COLOR.darkGray};
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
    letter-spacing: -0.4px;
    vertical-align: middle;
  }

  .close-icon {
    float: right;
    margin-left: auto;
    padding: 5px 0px;
  }

  .dialog-content {
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .dialog-actions {
    padding: 0px 24px 24px 24px;

    .dialog-actions-button {
      background-color: ${COLOR.primary};
      color: ${COLOR.darkGray};
      border-radius: 12px;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;

      &:disabled {
        pointer-events: all;
        opacity: 0.5;
        background-color: ${COLOR.primary};
        cursor: not-allowed;
      }
    }

    .circular-progress {
      color: ${COLOR.darkBlue};
    }

    .button-cancel {
      background-color: ${COLOR.white};
      border: 1px solid ${TRANSPARENT_COLOR.darkBlue};

      @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
        flex: 1;
      }
    }

    .button-save {
      @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
        flex: 1;
      }
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .dialog-actions {
      display: flex;
      justify-content: center;
      gap: 8px;
    }
  }
`;
